module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingMagiskt.1be3936e.png";